import errorMessage from '../../assets/lotties/error.json';
import LottieConfig from '../../components/UI/LottieConfig/LottieConfig';
import styled from 'styled-components';

function Error404() {
  const Text = styled.span`
    margin-top: 48px;
    font-size: 24px;
  `;

  const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    justify-content: center;
    align-items: center;
  `;

  return (
    <Wrapper>
      <LottieConfig animationData={errorMessage} customHeight={200} customWidth={200} />
      <Text>Error 404 - La pagina no existe</Text>
    </Wrapper>
  );
}

export default Error404;
